function upFirst(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}

export { upFirst };
//# sourceMappingURL=up-first.js.map
